import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import TypeAndDisplay from "./TypeAndDisplay";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<TypeAndDisplay />);
